// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Agreements_stepTitle__2t3Fg {
  font-size: 1.8rem;
  font-weight: 600;
  color: var(--primary-dark-blue);
  margin-bottom: 10px;
  text-align: center;
}

.Agreements_stepSubtext__qNYa1 {
  color: #6c757d;
  text-align: center;
  margin-top: 0;
  font-size: 1rem;
  
}

.Agreements_formContent__MtPwe {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-bottom: 10px;
  flex-direction: column;
  align-items: flex-start; 
}

.Agreements_checkboxGroup__o09jR {
  box-sizing: border-box;
  margin-top: 30px;
  display: flex;
  flex-direction: column;
  gap: 15px;
  padding: 20px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background-color: #fafafa;
  width: 100%;
  max-width: 700px;
}

.Agreements_checkboxContainer__Db0oF {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.Agreements_checkboxContainer__Db0oF input {

  width: 18px;
  height: 18px;
  margin-right: 8px;
}

.Agreements_checkboxText__wWEvj {
  font-size: 1rem;
  color: var(--primary-dark-blue);
  font-weight: 600;
}

.Agreements_inputGroup__eK6bi {
  margin-top: 20px;
  margin-bottom: 25px;
  max-width: 700px;
}

.Agreements_inputGroup__eK6bi label {
  display: block;
  font-weight: 500;
  margin-bottom: 8px;
  color: #6c757d;
  font-size: 0.9rem;
  line-height: 1.5; 
}

.Agreements_inputGroup__eK6bi input {
  box-sizing: border-box;
  width: 50%;
  padding: 12px 15px;
  border-radius: 8px;
  border: 1px solid #ccc;
  font-size: 1rem;
  font-family: 'Poppins', sans-serif;
  transition: border-color 0.3s ease, box-shadow 0.3s ease;
}

.Agreements_errorMessage__-Jrl4 {
  color: #e53e3e;
  font-size: 0.875rem;
  margin-top: 5px;
}

.Agreements_agreementItem__XZVxw {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.Agreements_downloadLink__1Y4-1:hover {
  background-color: #e0e0e0;
}

.Agreements_downloadIcon__gaQ4U {
  font-size: 1.1rem;
}

.Agreements_linkContainer__BK1ij {
  display: flex;
  align-items: center;
  gap: 12px;
}

.Agreements_openLink__KKSKN {
  font-size: 1em;
  color: var(--primary-dark-blue);
  text-decoration: none;
  cursor: pointer;
}

.Agreements_openLink__KKSKN:hover {
  opacity: 0.7;
}

.Agreements_downloadLink__1Y4-1 {
  color: var(--primary-dark-blue);
  text-decoration: none;
  display: flex;
  align-items: center;
  padding: 5px;
  border-radius: 50%;
  transition: background-color 0.2s ease-in-out;
}

@media (max-width: 768px) {
  .Agreements_inputGroup__eK6bi input {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/RegistrationForm/steps/Agreements/Agreements.module.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,+BAA+B;EAC/B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,eAAe;;AAEjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,kCAAkC;EAClC,wDAAwD;AAC1D;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,+BAA+B;EAC/B,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,+BAA+B;EAC/B,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,6CAA6C;AAC/C;;AAEA;EACE;IACE,WAAW;EACb;AACF","sourcesContent":[".stepTitle {\n  font-size: 1.8rem;\n  font-weight: 600;\n  color: var(--primary-dark-blue);\n  margin-bottom: 10px;\n  text-align: center;\n}\n\n.stepSubtext {\n  color: #6c757d;\n  text-align: center;\n  margin-top: 0;\n  font-size: 1rem;\n  \n}\n\n.formContent {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  margin-bottom: 10px;\n  flex-direction: column;\n  align-items: flex-start; \n}\n\n.checkboxGroup {\n  box-sizing: border-box;\n  margin-top: 30px;\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n  padding: 20px;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  background-color: #fafafa;\n  width: 100%;\n  max-width: 700px;\n}\n\n.checkboxContainer {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n}\n\n.checkboxContainer input {\n\n  width: 18px;\n  height: 18px;\n  margin-right: 8px;\n}\n\n.checkboxText {\n  font-size: 1rem;\n  color: var(--primary-dark-blue);\n  font-weight: 600;\n}\n\n.inputGroup {\n  margin-top: 20px;\n  margin-bottom: 25px;\n  max-width: 700px;\n}\n\n.inputGroup label {\n  display: block;\n  font-weight: 500;\n  margin-bottom: 8px;\n  color: #6c757d;\n  font-size: 0.9rem;\n  line-height: 1.5; \n}\n\n.inputGroup input {\n  box-sizing: border-box;\n  width: 50%;\n  padding: 12px 15px;\n  border-radius: 8px;\n  border: 1px solid #ccc;\n  font-size: 1rem;\n  font-family: 'Poppins', sans-serif;\n  transition: border-color 0.3s ease, box-shadow 0.3s ease;\n}\n\n.errorMessage {\n  color: #e53e3e;\n  font-size: 0.875rem;\n  margin-top: 5px;\n}\n\n.agreementItem {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.downloadLink:hover {\n  background-color: #e0e0e0;\n}\n\n.downloadIcon {\n  font-size: 1.1rem;\n}\n\n.linkContainer {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.openLink {\n  font-size: 1em;\n  color: var(--primary-dark-blue);\n  text-decoration: none;\n  cursor: pointer;\n}\n\n.openLink:hover {\n  opacity: 0.7;\n}\n\n.downloadLink {\n  color: var(--primary-dark-blue);\n  text-decoration: none;\n  display: flex;\n  align-items: center;\n  padding: 5px;\n  border-radius: 50%;\n  transition: background-color 0.2s ease-in-out;\n}\n\n@media (max-width: 768px) {\n  .inputGroup input {\n    width: 100%;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"stepTitle": `Agreements_stepTitle__2t3Fg`,
	"stepSubtext": `Agreements_stepSubtext__qNYa1`,
	"formContent": `Agreements_formContent__MtPwe`,
	"checkboxGroup": `Agreements_checkboxGroup__o09jR`,
	"checkboxContainer": `Agreements_checkboxContainer__Db0oF`,
	"checkboxText": `Agreements_checkboxText__wWEvj`,
	"inputGroup": `Agreements_inputGroup__eK6bi`,
	"errorMessage": `Agreements_errorMessage__-Jrl4`,
	"agreementItem": `Agreements_agreementItem__XZVxw`,
	"downloadLink": `Agreements_downloadLink__1Y4-1`,
	"downloadIcon": `Agreements_downloadIcon__gaQ4U`,
	"linkContainer": `Agreements_linkContainer__BK1ij`,
	"openLink": `Agreements_openLink__KKSKN`
};
export default ___CSS_LOADER_EXPORT___;
